export class MidiDeviceSettings {
  id: string;
  name: string;
  dateTimeConfiguredMS: number;
  numberOfKeys: number | string;
  lowestNote: number;
  highestNote: number;

  constructor({ id, name, numberOfKeys, lowestNote, highestNote }: MidiDeviceSettings) {
    Object.assign(this, { id, name, numberOfKeys, lowestNote, highestNote });
    this.dateTimeConfiguredMS = (new Date()).getTime();
  }
}